/** The `phases` area: the Stages page. Owned by the stage 2 slot flows
 *  (docs/I18N.md §11). The keys read in page order: the head, the filter, a
 *  flow's entry, its pipeline and a member's card. */
export const phases = {
  // --- The page head ---
  'phases.page.title': 'Stages',
  /** The sub-line with no flow yet. */
  'phases.page.sub': 'flow pipelines',
  /** The sub-line's counts: "3 items across 2 flows". */
  'phases.page.across': '{items} across {flows}',
  'phases.items': { one: '{count} item', other: '{count} items' },
  'phases.page.flows': { one: '{count} flow', other: '{count} flows' },
  /** The flagged count of members whose boundary waits on a verdict. */
  'phases.verdicts': { one: '{count} needs a verdict', other: '{count} need a verdict' },
  'phases.page.empty':
    "No flows yet. A flow is an ordered pipeline of stages, decisions at the boundaries - and every item that joins one shows up here as a pipeline. Create one under Flows, then add items from their page or a board whose columns are a flow's stages.",
  // --- The filter ---
  'phases.filter.label': 'Filter flow members',
  'phases.filter.all': 'All',
  'phases.filter.verdict': 'Needs verdict',
  'phases.filter.emptyVerdict': 'No stage is waiting on a verdict. The agenda is empty.',
  'phases.filter.emptyAll': 'No flows yet.',
  // --- A flow's entry and its pipeline ---
  'phases.flow.noMembers': 'no members yet',
  'phases.flow.configure': 'configure',
  'phases.flow.empty':
    "No items in this flow yet. Add them from an item's page (+ Flow) or a board whose columns are its stages.",
  /** The column for members whose position is no longer one of the flow's stages. */
  'phases.pipeline.drifted': 'No longer a stage',
  // --- A member's card ---
  /** The member's own atoms, as quiet words. */
  'phases.card.closed': 'closed',
  'phases.card.delivered': 'done',
  'phases.card.verdict.accepted': 'accepted',
  'phases.card.verdict.disputed': 'denied',
  /** A recorded hold at the current boundary, with its reason if one was given. */
  'phases.card.heldTitle': 'Held',
  'phases.card.heldTitleReason': 'Held: {reason}',
  'phases.card.held': 'held',
  'phases.card.heldReason': 'held: {reason}',
  /** A drifted member's stored position key. */
  'phases.card.position': 'position "{key}"',
  'phases.card.needsVerdict': 'needs verdict',
  'phases.card.unmet': '{count} not met at this boundary',
} as const;
